import { Divider, Flex, Icon } from '@chakra-ui/react';
import { RiAccountCircleFill } from '@react-icons/all-files/ri/RiAccountCircleFill';
import React, { useEffect, useState } from 'react';
import { decodeToken } from 'react-jwt';

import { ACCOUNT_LOGIN, DASHBOARD } from '../../constants/urls';
import {
  ExternalCustomer,
  useCheckExistingAccountByEmailQuery,
  useGetByAuth0IdLazyQuery,
} from '../../gql/generated/graphql';
import { CookieKeys, useCookie } from '../../hooks/useCookie';
import { logout } from '../../services/auth0';
import { EMAIL_KEY, JWTToken } from '../../utils/auth';
import ProfileModal from '../ProfileModal';
import SidebarAccountHeader from '../Sidebar/SidebarAccountHeader';
import SidebarNavLink from '../Sidebar/SidebarNavLink';

const SidebarAuthMenu = () => {
  const [customer, setCustomer] = useState<ExternalCustomer>();
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const [accessToken] = useCookie<string>(CookieKeys.ACCESS_TOKEN);
  const { [EMAIL_KEY]: email } = decodeToken<JWTToken>(accessToken ?? '') ?? {};
  const [getCustomer] = useGetByAuth0IdLazyQuery({
    onCompleted: (data) => {
      setCustomer(data?.getByAuth0Id as ExternalCustomer);
    },
  });

  const { data: hasAccount } = useCheckExistingAccountByEmailQuery({
    fetchPolicy: 'network-only',
    variables: {
      email: email ?? '',
    },
    skip: !email,
  });

  useEffect(() => {
    if (accessToken) {
      getCustomer();
    }
  }, [accessToken]);

  return accessToken ? (
    <>
      <SidebarAccountHeader name={customer?.full_name} email={customer?.email} />
      <Flex flexDir="column" gap="15px" mt="10px">
        <SidebarNavLink onClick={() => setProfileModalOpen(true)}>Profile</SidebarNavLink>
        <SidebarNavLink to={DASHBOARD}>Dashboard</SidebarNavLink>
        <SidebarNavLink onClick={() => logout()}>Logout</SidebarNavLink>
      </Flex>
      {hasAccount?.checkExistingAccountByEmail && (
        <>
          <Divider m="10px 0" />
          <ProfileModal open={profileModalOpen} setOpen={setProfileModalOpen} customer={customer} />
        </>
      )}
    </>
  ) : (
    <>
      <Flex alignItems="center" gap="5px">
        <Icon as={RiAccountCircleFill} boxSize="30px" color="white" />
        <SidebarNavLink to={ACCOUNT_LOGIN} mt="3px">
          Login
        </SidebarNavLink>
      </Flex>
      <Divider m="10px 0" />
    </>
  );
};

export default SidebarAuthMenu;
